import { useAtomValue } from 'jotai';
import type { ReactNode } from 'react';

import { userAtom } from '@/stores/auth.store';

import { getRegulatoryText } from '../constants/regulatory-text';

import { WizardSidebar } from './wizard-sidebar';
import { WizardStepper } from './wizard-stepper';

interface WizardLayoutProps {
  children: ReactNode;
  currentStep?: number;
  completedSteps?: number[];
}

export function WizardLayout({
  children,
  currentStep = 1,
  completedSteps = [],
}: WizardLayoutProps) {
  const user = useAtomValue(userAtom);
  const regulatoryText = getRegulatoryText(user?.company?.industry);

  return (
    <div className="flex min-h-[calc(100vh-64px)] flex-col xl:flex-row">
      {/* Left Sidebar - Hidden on mobile/tablet, visible on xl desktop */}
      <WizardSidebar currentStep={currentStep} completedSteps={completedSteps} />

      {/* Mobile/Tablet Header - Visible on mobile/tablet, hidden on xl desktop */}
      <div className="p-4 xl:hidden">
        <div className="rounded-[5px] bg-[#E8EBED] p-4">
          <h2 className="mb-3 text-[18px] font-semibold text-[#051923]">Client Risk Assessment</h2>
          <p className="mb-4 text-[13px] leading-relaxed text-[#051923]">{regulatoryText}</p>
          <WizardStepper
            currentStep={currentStep}
            completedSteps={completedSteps}
            variant="vertical"
          />
        </div>
      </div>

      {/* Main Content Area - Full width on mobile/tablet, offset for sidebar on xl desktop */}
      <main className="flex-1 pb-48 md:pb-24 xl:ml-[412px] xl:mr-[412px]">{children}</main>
    </div>
  );
}
